import { render } from "./SidebarButton.vue?vue&type=template&id=8c0f5464&scoped=true"
import script from "./SidebarButton.vue?vue&type=script&lang=js"
export * from "./SidebarButton.vue?vue&type=script&lang=js"

import "./SidebarButton.vue?vue&type=style&index=0&id=8c0f5464&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0f5464"]])

export default __exports__